<div layout="row" layout-wrap="false" [ngClass]="[
		styles.container,
		isActive ? styles.activeEntry : ''
	]">

	<a [ngClass]="styles.link" (click)="onClick()" role="button" [attr.aria-label]="'Time_In_Video' | translate : { '0':  entry.startSecs * SecondMs | vbTimespan : showHours : true }">
		{{ entry.startSecs * SecondMs | vbTimespan : showHours : true }}
	</a>

	<a (click)="onClick()" *ngIf="isTaggedUser" role="button">
		<vb-profile-picture [ngClass]="styles.profilePicture" [altTxt]="'UserProfile_ProfilePicture' | translate" [profileUrl]="entry.photoUrl" [size]="'large'">
		</vb-profile-picture>
	</a>

	<a flex="fill" [ngClass]="[styles.link, styles.text]" (click)="onClick()" role="button">

		<span *ngIf="isTranscription" [innerHTML]="entry.text | safeHtml">
		</span>

		<span *ngIf="isTaggedUser">
			<span *ngIf="isTaggedUserWithoutRange">
				{{ 'Media_Videos_Pulse_UserTagged_NoRange' | translate : { '0': entry.filterValue } }}
			</span>

			<span *ngIf="!isTaggedUserWithoutRange">
				{{ 'Media_Videos_Pulse_UserTagged_WithRange' | translate : {
					'0': entry.filterValue,
					'1': (entryDurationMs | vbTimespan : false : true )
				} }}
			</span>
		</span>
	</a>

	<div [ngClass]="styles.editMenu">
		<div dropdown #dropdown="bs-dropdown" [dropup]="dropup" container="body" *ngIf="isTranscription && canEdit" [isOpen]="openedEdit === entry" [autoClose]="false">
			<button class="btn dropdown-toggle" type="button" [attr.aria-label]="'Media_Videos_Pulse_EditSubtitle' | translate" dropdownToggle (click)="onEditToggled.emit(entry)">
				<span class="glyphicons pencil"></span>
			</button>
			<div *dropdownMenu class="dropdown-menu dropdown-menu-right rounded" [ngClass]="styles.dropdownMenu">
				<edit-pulse-subtitle *ngIf="dropdown.isOpen" [entry]="entry" (cancel)="onEditToggled.emit()" (save)="saveSubtitle($event)" (delete)="deleteSubtitle($event)">
				</edit-pulse-subtitle>
			</div>
		</div>
	</div>
</div>

<vb-confirmation-dialog [title]="'Delete' | translate" [innerHTML]="'Media_Videos_Pulse_Entry_Delete' | translate : { '0': entry.text } | safeHtml" [cancelText]="'Cancel' | translate" [actionText]="'Delete' | translate">
</vb-confirmation-dialog>
